function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
define('TescoMobile_BoPo/js/view/deal-device-delivery-date-mixin',['jquery', 'mage/translate', 'Magento_Customer/js/customer-data', '../stock-status-lookup'], function ($, $t, customerData, stockStatusLookup) {
  'use strict';

  const mixin = {
    defaults: {
      dealDeviceWrapperSelector: '#tm-deal-device-wrapper',
      deviceStockWrapperSelector: '#tm-deal-device-stock-wrapper',
      postcodeStockLookupSelector: '#postcode-stock-lookup',
      deliveryCounterSelector: '.delivery-counter-wrapper',
      deliveryCounterInvisibleOnStockStatus: [stockStatusLookup.preorderInStock, stockStatusLookup.backorderInStock, stockStatusLookup.preorderOutOfStock, stockStatusLookup.backorderOutOfStock],
      estimatedDeliveryMessageVisibleOnStockStatus: [stockStatusLookup.preorderInStock, stockStatusLookup.backorderInStock],
      preorderStatuses: [stockStatusLookup.preorderInStock, stockStatusLookup.preorderOutOfStock],
      backorderStatuses: [stockStatusLookup.backorderInStock, stockStatusLookup.backorderOutOfStock],
      addToCartButtonInvisibleOnStockStatus: [stockStatusLookup.preorderOutOfStock, stockStatusLookup.backorderOutOfStock]
    },
    initialize: function () {
      this._super();
      this.warehouseStockStatus.subscribe(this.handleWarehouseStockStatusChange, this);
      let self = this;
      $('body').on('postcodeStockLookupRendered', function () {
        let selectedDeviceOption = self._getSelectedDeviceOption();
        let stockStatus = selectedDeviceOption === null || selectedDeviceOption === void 0 ? void 0 : selectedDeviceOption.stock_status;
        self.updateStockLookup(stockStatus);
      });
      this.handleWarehouseStockStatusChange(this.warehouseStockStatus());
    },
    _updateStockMessage: function (deviceOption) {
      this._super(deviceOption);
      if (deviceOption !== null && deviceOption !== void 0 && deviceOption.delivery_date && this.estimatedDeliveryMessageVisibleOnStockStatus.includes(deviceOption.stock_status)) {
        this.stockAvailability(this.stockAvailability() + '<div>' + $t('Delivered by') + '<span>' + deviceOption.delivery_date + '</span></div>');
      }
      if (this.addToCartButtonInvisibleOnStockStatus.includes(deviceOption.stock_status)) {
        this.warehouseStockStatus(0);
      }
    },
    _getStockClass: function (status) {
      switch (status) {
        case stockStatusLookup.preorderInStock:
        case stockStatusLookup.backorderInStock:
          return 'pending-stock in-stock';
        case stockStatusLookup.preorderOutOfStock:
          return 'pending-stock oos';
        case stockStatusLookup.backorderOutOfStock:
          return 'oos';
      }
      return this._super(status);
    },
    getBranchId: function () {
      var _caseDetails;
      const caseDetails = customerData.get('case-details');
      return (_caseDetails = caseDetails()) === null || _caseDetails === void 0 || (_caseDetails = _caseDetails.store) === null || _caseDetails === void 0 ? void 0 : _caseDetails.number;
    },
    handleWarehouseStockStatusChange: function (status) {
      if (this.getBranchId()) {
        if (this.preorderStatuses.includes(status)) {
          $(this.dealDeviceWrapperSelector).removeClass('hide-stock');
          $(this.dealDeviceWrapperSelector).addClass('show-preorder-stock-phoneshop');
          $(this.deviceStockWrapperSelector).addClass('hide-stock');
        } else if (this.backorderStatuses.includes(status)) {
          $(this.dealDeviceWrapperSelector).removeClass('hide-stock');
          $(this.deviceStockWrapperSelector).addClass('hide-stock');
        } else {
          $(this.dealDeviceWrapperSelector).addClass('hide-stock');
          $(this.deviceStockWrapperSelector).removeClass('hide-stock');
          $(this.dealDeviceWrapperSelector).removeClass('show-preorder-stock-phoneshop');
        }
      }
    },
    updateStockLookup: function (status) {
      if (this.preorderStatuses.includes(status)) {
        $(this.postcodeStockLookupSelector).hide();
      } else {
        $(this.postcodeStockLookupSelector).show();
      }
    },
    updateDeliveryCounterVisibility: function (status) {
      if (this.deliveryCounterInvisibleOnStockStatus.includes(status)) {
        $(this.deliveryCounterSelector).hide();
      } else {
        $(this.deliveryCounterSelector).show();
      }
    },
    _updateAddToCartButton: function (selectedDeviceOption) {
      let status = selectedDeviceOption.stock_status;
      this.updateDeliveryCounterVisibility(status);
      this.updateStockLookup(status);
      let selectedDeviceOptionCopy = _objectSpread({}, selectedDeviceOption);
      if (this.addToCartButtonInvisibleOnStockStatus.includes(status)) {
        selectedDeviceOptionCopy.stock_status = 0;
      }
      this._super(selectedDeviceOptionCopy);
    }
  };
  return function (target) {
    return target.extend(mixin);
  };
});

